import './style.scss'

import { Media } from '../../../js/utils/const'
import { pushDSPCounter } from '../../../js/libs/pixel'
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'

export default !function () {
  const block = document.querySelector('.qs-start-screen-v1')

  if (!block) {
    return
  }

  const blockName = block.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'
  const buttons = block.querySelectorAll('.qs-start-screen-v1__button')

  if (buttons.length) {
    const blocksWithFooter = document.querySelectorAll('.footer')
    const blocksWithButton = [...document.querySelectorAll('.block:not(.qs-start-screen-v1)')]
      .filter(block => block.querySelector('.ui-button'))
    const blocks = [...blocksWithButton, ...blocksWithFooter]
    const bar = document.querySelector('.qs-start-screen-v1__bar--mobile')

    buttons.forEach(button => {
      const siteArea = button.dataset.pixel

      button.addEventListener('click', (evt) => {
        button.dataset.actionButton && evt.preventDefault()

        const buttonType = button.dataset.actionButton || (button.dataset.redirectLink && 'redirect')

        if (buttonType) {
          window.$analytics?.push('all-block-consult-button-click', {
            blockName,
            buttonType,
            buttonText: button.textContent
          })
        }

        if (button.dataset.actionButton === 'order-modal') {
          const blockName = button.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'
          showOrderModal({ blockName })
        }

        siteArea && pushDSPCounter(siteArea)
      })
    })

    let visibleCount = 1
    const media = window.matchMedia(`(max-width: ${Media.MD_MAX}px)`)

    const changeVisibleButton = (entries) => {
      entries.forEach(entry => {
        entry.isIntersecting ? ++visibleCount : --visibleCount
        visibleCount = visibleCount > 0 ? visibleCount : 0

        visibleCount
          ? bar.classList.add('qs-start-screen-v1__bar--hidden')
          : bar.classList.remove('qs-start-screen-v1__bar--hidden')
      })
    }

    const observer = new IntersectionObserver(changeVisibleButton)

    const mediaChangeHandler = () => {
      media.matches
        ? blocks.forEach(block => observer.observe(block))
        : observer.disconnect()
    }

    mediaChangeHandler()
    media.addEventListener('change', mediaChangeHandler)
  }
}()
